import { bindActionCreators } from "@reduxjs/toolkit"
import { useMemo } from "react"
import { useAppDispatch } from "../../../../app/store/store"
import { MySlice } from "../../model/reducers/MySlice"




export const useMyActions = () => {
    const dispatch = useAppDispatch()
    return useMemo(() => bindActionCreators(MySlice.actions, dispatch), [dispatch])
}
